module.exports = __webpack_public_path__ + "img/frich_westernsjangeren.53fa9dac.jpg";